import { makeStyles } from '@material-ui/styles';
import { dangerColor } from 'assets/jss/material-dashboard-pro-react';

import DatePickerField from './DatePickerField/DatePickerField';

const useStyles = makeStyles({
  title: {
    marginBottom: '6px',
    fontSize: '14px',
    fontWeight: '400',
  },
  dates: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: '16px',
  },
  error: {
    margin: '8px 0 0',
    fontSize: '14px',
    color: dangerColor[0],
  },
});

const DateRange = ({
  className,
  title,
  errorMessage,
  dataRange: [dateFrom, dateTo],
  onDateRangeChange,
  labelFrom,
  labelTo,
}) => {
  const classes = useStyles();

  return (
    <div className={className}>
      <p className={classes.title}>{title}</p>
      <div className={classes.dates}>
        <DatePickerField
          label={labelFrom}
          value={dateFrom}
          onChange={date => {
            onDateRangeChange([date, dateTo]);
          }}
        />
        <DatePickerField
          label={labelTo}
          value={dateTo}
          onChange={date => {
            onDateRangeChange([dateFrom, date]);
          }}
        />
      </div>
      {errorMessage && <p className={classes.error}>{errorMessage}</p>}
    </div>
  );
};

export default DateRange;
